/*@flow*/
import qs from 'qs';

export default function isEmbedded(): %checks {
  return Boolean(
    /\/embed/.test(window.location.pathname) ||
      (qs.parse(window.location.search.slice(1)) || {}).embed
  );
}
